import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useSubscription } from '../contexts/SubscriptionContext';

const useWriteGuard = () => {
  const { isWriteBlocked, subscriptionStatus } = useSubscription();

  const guardWrite = useCallback((action) => {
    if (isWriteBlocked) {
      toast.warning(
        subscriptionStatus === 'suspended'
          ? 'Account suspended. Please complete payment to continue.'
          : 'Account restricted. Please complete payment to be able to add new information.',
        { toastId: 'write-guard' }
      );
      return false;
    }
    if (typeof action === 'function') {
      action();
    }
    return true;
  }, [isWriteBlocked, subscriptionStatus]);

  return { isWriteBlocked, guardWrite };
};

export default useWriteGuard;
